import React from 'react'
import usePostsQuery from '../hooks/use-posts-query'
import { GatsbyImage } from 'gatsby-plugin-image'
import Link from '../utils/link'
import BlogSearch from './blog-search'
import { Fade } from 'react-reveal'

const Blog = ({ title }) => {
  const { posts, categories, tags } = usePostsQuery()

  // State
  const [list, setList] = React.useState(posts)
  const [limit, setLimit] = React.useState(10)

  // Ref
  const load = React.createRef()

  // Events
  let timeout = null
  const onScroll = () => {
    let position = load?.current?.getBoundingClientRect()
    if (!position) return
    if (position.top >= 0 && position.bottom <= window.innerHeight) {
      if (!timeout) {
        //if (!this.timeout && this.state.length < this.state.list) {
        timeout = setTimeout(() => {
          setLimit(limit + 6)
          timeout = null
        }, 10)
      }
    } else {
      clearTimeout(timeout)
    }
  }

  // Update
  React.useEffect(() => {
    window.addEventListener('scroll', onScroll)
    return () => {
      window.removeEventListener('scroll', onScroll)
    }
  })

  return (
    <section className='blog'>
      <Fade bottom distance='40px'>
        <div className='blog__inner'>
          { title && < h1> { title }</h1> }
        </div>
      </Fade>
      <div className='blog__items'>
        <BlogSearch
          list={ posts || [] }
          set={ setList }
          categories={ categories }
          tags={ tags }
        />
        { list?.slice(0, limit).map((el, i) => (
          <div key={ el.id } to={ el.uri } className='blog__item'>
            <Fade bottom distance='40px'>
              <>
                <div className='blog__image'>
                  <Link to={ `/blog/${el.slug}`}>{ el.featuredImage?.node.localFile && <GatsbyImage image={ el.featuredImage.node.localFile.childImageSharp.gatsbyImageData } alt=''/> }</Link>
                </div>
                <div className='blog__content'>
                  { el.title && <h4><Link to={ `/blog/${el.slug}`}>{ el.title }</Link></h4> }
                </div>
                <div className='blog__cate'>
                  { el.date && <p>{ el.date }</p> }
                  { el.categories?.nodes?.length && <span className='btn btn-border-powder'><Link to={ `/blog/?category=${el.categories.nodes[0].slug}`}>{ el.categories.nodes[0].name }</Link></span> }
                </div>
              </>
            </Fade>
          </div>
        )) }
        { list?.length === 0 && <p className='blog__no-results'>No posts match your search criteria. Please try again.</p> }
      </div>
      <div ref={load} />
    </section>
  )
}

export default Blog